<eo-dropdown
  [id]="id"
  [config]="getConfig()"
  [label]="label"
  [help]="help"
  [errors]="errors"
  [tabindex]="tabIndex"
  [options]="(httpData$ | async) ?? options ?? []"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [placeholder]="placeholder"
  [showClear]="showClear"
  [filter]="filter"
  [filterBy]="filterBy"
  [filterFields]="filterFields"
  [filterPlaceholder]="filterPlaceholder"
  [loading]="loading"
  [appendTo]="getAppendTo()"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
/>
